<template>
    <!-- start page title -->
    <div class="row">
        <div class="col-12">
            <div class="page-title-box">
                <h4 class="page-title">Project Details</h4>
            </div>
        </div>
    </div>     
    <!-- end page title --> 

    <div class="row">
        <div class="col-xxl-8 col-lg-6">
            <!-- project card -->
            <div class="card d-block">
                <div class="card-body">
                    <div class="dropdown float-end">
                        <a href="#" class="dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="dripicons-dots-3"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                            <!-- item-->
                            <a href="javascript:void(0);" class="dropdown-item" :id="project.id" @click="edit(project)"><i class="mdi mdi-pencil me-1"></i>Edit</a>
                            <!-- item-->
                            <a href="javascript:void(0);" class="dropdown-item"><i class="mdi mdi-delete me-1"></i>Delete</a>
                        </div>
                    </div>
                    <!-- project title-->
                    <h3 class="mt-0">
                        {{ project.project_name }}
                    </h3>
                    <div class="badge bg-secondary text-light mb-3">Ongoing</div>

                    <h5>Project Overview:</h5>

                    <p class="text-muted mb-2" v-if="project.details">
                        {{ project.details.description }}
                    </p>

                    <div class="row">
                        <div class="col-md-4">
                            <div class="mb-4">
                                <h5>Start Date</h5>
                                <p>{{ formatDate(project.start_date) }}</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-4">
                                <h5>End Date</h5>
                                <p>{{ formatDate(project.end_date) }}</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-4">
                                <h5>Budget</h5>
                                <p>{{ project.effort }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <h5>Owner:</h5>
                            <p>{{ project.lead.name }}</p>
                        </div>

                        <div class="col-md-4">
                            <h5>Lead:</h5>
                            <p>{{ project.lead.name }}</p>
                        </div>
                    </div>

                </div> <!-- end card-body-->
                
            </div> <!-- end card-->

            <!-- end card-->
        </div> <!-- end col -->

        <div class="col-lg-6 col-xxl-4">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title mb-3">Progress</h5>
                    <div dir="ltr">
                        <div class="mt-3 chartjs-chart" style="height: 320px;">
                            <canvas id="line-chart-example"></canvas>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end card-->

            <!-- 
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title mb-3">Files</h5>

                    <div class="card mb-1 shadow-none border">
                        <div class="p-2">
                            <div class="row align-items-center">
                                <div class="col-auto">
                                    <div class="avatar-sm">
                                        <span class="avatar-title rounded">
                                            .ZIP
                                        </span>
                                    </div>
                                </div>
                                <div class="col ps-0">
                                    <a href="javascript:void(0);" class="text-muted fw-bold">Hyper-admin-design.zip</a>
                                    <p class="mb-0">2.3 MB</p>
                                </div>
                                <div class="col-auto">
                                    
                                    <a href="javascript:void(0);" class="btn btn-link btn-lg text-muted">
                                        <i class="dripicons-download"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-1 shadow-none border">
                        <div class="p-2">
                            <div class="row align-items-center">
                                <div class="col-auto">
                                    <img src="assets/images/projects/project-1.jpg" class="avatar-sm rounded" alt="file-image" />
                                </div>
                                <div class="col ps-0">
                                    <a href="javascript:void(0);" class="text-muted fw-bold">Dashboard-design.jpg</a>
                                    <p class="mb-0">3.25 MB</p>
                                        </div>
                                <div class="col-auto">
                                    
                                    <a href="javascript:void(0);" class="btn btn-link btn-lg text-muted">
                                        <i class="dripicons-download"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-0 shadow-none border">
                        <div class="p-2">
                            <div class="row align-items-center">
                                <div class="col-auto">
                                    <div class="avatar-sm">
                                        <span class="avatar-title bg-secondary text-light rounded">
                                            .MP4
                                        </span>
                                    </div>
                                </div>
                                <div class="col ps-0">
                                    <a href="javascript:void(0);" class="text-muted fw-bold">Admin-bug-report.mp4</a>
                                    <p class="mb-0">7.05 MB</p>
                                </div>
                                <div class="col-auto">
                                    
                                    <a href="javascript:void(0);" class="btn btn-link btn-lg text-muted">
                                        <i class="dripicons-download"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>-->
        </div>

        <div class="col-xxl-6 col-lg-6">
            <!-- project card -->
            <div class="card d-block">
                <div class="card-body">
                    <!-- project title-->
                    <h3 class="mt-0">
                        Project Pipeline
                    </h3>

                    <form @submit.prevent="submitPipeline">

                        <div class="row">

                            <div class="col-md-3 mt-2">
                                <label class="form-label">Lead</label>
                                <input type="date" v-model="pipeline.lead" class="form-control" autofocus aria-describedby="startDateFeedback" :class="{'form-control':true, 'is-invalid':errors.lead ? true : false}" data-provide="datepicker" data-date-container="#lead" data-date-format="d-M-yyyy" data-date-autoclose="true">
                                <div v-if="errors.lead" id="startDateFeedback" class="invalid-feedback">
                                    {{errors.lead}}
                                </div>
                            </div>

                            <div class="col-md-3 mt-2">
                                <label class="form-label">Develop</label>
                                <input type="date" v-model="pipeline.develop" class="form-control" autofocus aria-describedby="startDateFeedback" :class="{'form-control':true, 'is-invalid':errors.develop ? true : false}" data-provide="datepicker" data-date-container="#develop" data-date-format="d-M-yyyy" data-date-autoclose="true">
                                <div v-if="errors.develop" id="startDateFeedback" class="invalid-feedback">
                                    {{errors.develop}}
                                </div>
                            </div>

                            <div class="col-md-3 mt-2">
                                <label class="form-label">Propose</label>
                                <input type="date" v-model="pipeline.propose" class="form-control" autofocus aria-describedby="startDateFeedback" :class="{'form-control':true, 'is-invalid':errors.propose ? true : false}" data-provide="datepicker" data-date-container="#propose" data-date-format="d-M-yyyy" data-date-autoclose="true">
                                <div v-if="errors.propose" id="startDateFeedback" class="invalid-feedback">
                                    {{errors.propose}}
                                </div>
                            </div>

                            <div class="col-md-3 mt-2">
                                <label class="form-label">Contract</label>
                                <input type="date" v-model="pipeline.contract" class="form-control" autofocus aria-describedby="startDateFeedback" :class="{'form-control':true, 'is-invalid':errors.contract ? true : false}" data-provide="datepicker" data-date-container="#contract" data-date-format="d-M-yyyy" data-date-autoclose="true">
                                <div v-if="errors.contract" id="startDateFeedback" class="invalid-feedback">
                                    {{errors.contract}}
                                </div>
                            </div>

                            <div class="col-md-3 mt-2">
                                <label class="form-label">Initiate</label>
                                <input type="date" v-model="pipeline.initiate" class="form-control" autofocus aria-describedby="startDateFeedback" :class="{'form-control':true, 'is-invalid':errors.initiate ? true : false}" data-provide="datepicker" data-date-container="#initiate" data-date-format="d-M-yyyy" data-date-autoclose="true">
                                <div v-if="errors.initiate" id="startDateFeedback" class="invalid-feedback">
                                    {{errors.initiate}}
                                </div>
                            </div>

                            <div class="col-md-3 mt-2">
                                <label class="form-label">Run</label>
                                <input type="date" v-model="pipeline.run" class="form-control" autofocus aria-describedby="startDateFeedback" :class="{'form-control':true, 'is-invalid':errors.run ? true : false}" data-provide="datepicker" data-date-container="#run" data-date-format="d-M-yyyy" data-date-autoclose="true">
                                <div v-if="errors.run" id="startDateFeedback" class="invalid-feedback">
                                    {{errors.run}}
                                </div>
                            </div>

                            <div class="col-md-3 mt-2">
                                <label class="form-label">Wrap-up</label>
                                <input type="date" v-model="pipeline.wrap_up" class="form-control" autofocus aria-describedby="startDateFeedback" :class="{'form-control':true, 'is-invalid':errors.wrap_up ? true : false}" data-provide="datepicker" data-date-container="#wrap_up" data-date-format="d-M-yyyy" data-date-autoclose="true">
                                <div v-if="errors.wrap_up" id="startDateFeedback" class="invalid-feedback">
                                    {{errors.wrap_up}}
                                </div>
                            </div>

                            <div class="col-md-3 mt-2">
                                <label class="form-label">Bill</label>
                                <input type="date" v-model="pipeline.bill" class="form-control" autofocus aria-describedby="startDateFeedback" :class="{'form-control':true, 'is-invalid':errors.bill ? true : false}" data-provide="datepicker" data-date-container="#bill" data-date-format="d-M-yyyy" data-date-autoclose="true">
                                <div v-if="errors.bill" id="startDateFeedback" class="invalid-feedback">
                                    {{errors.bill}}
                                </div>
                            </div>

                            <div class="col-md-3 mt-2">
                                <label class="form-label">Close</label>
                                <input type="date" v-model="pipeline.close" class="form-control" autofocus aria-describedby="startDateFeedback" :class="{'form-control':true, 'is-invalid':errors.close ? true : false}" data-provide="datepicker" data-date-container="#close" data-date-format="d-M-yyyy" data-date-autoclose="true">
                                <div v-if="errors.close" id="startDateFeedback" class="invalid-feedback">
                                    {{errors.close}}
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-2">
                                <button type="submit" class="btn btn-primary btn-sm mt-3">Submit</button>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>

        <div class="col-xxl-6 col-lg-6">
            <!-- project card -->
            <div class="card d-block">
                <div class="card-body">
                    <!-- project title-->
                    <h3 class="mt-0">
                        Project Members
                    </h3>

                    <div class="row">

                        <div v-for="(member, key) in project.members" :key="member.id" class="col-md-3 mt-2">

                            <p class="single-member">
                                {{ member.user.name }}

                                <span class="remove-member-icon" @click="removeMember(member.id, key)">
                                    <i class="uil-times-circle"></i>
                                </span>
                            </p>

                        </div>

                    </div>

                    <div class="row">
                        <div class="col-md-3 mt-2">
                            <label for="new_member" class="form-label">New member:</label>
                            <div class="input-group has-validation">
                                <select :class="{'form-select':true}" id="new_member" v-model="new_member">
                                    <option v-for="user in users" :key="user.id" :value="user.id">{{ user.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3 mt-4">
                            <button type="button" @click="addMember(new_member)" class="btn btn-primary">Add member</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-xxl-12 col-lg-12">
            <div class="card">
                <div class="card-body">
                    <Phases :project="project" :users="users" />

                    <!--<div class="text-center mt-2">
                        <a href="javascript:void(0);" class="text-danger">Load more </a>
                    </div>-->
                </div> <!-- end card-body-->
            </div>
        </div>

        <div class="col-xxl-12 col-lg-12">
            <div class="card">
                <div class="card-body">
                    <h4 class="mt-0 mb-3">Comments ({{ project.comments.length }})</h4>
                    <form @submit.prevent="submitComment">
                        <textarea class="form-control form-control-light mb-2" v-model="newComment" placeholder="Write message" id="example-textarea" rows="3"></textarea>
                        <div class="text-end">
                            <!--<div class="btn-group mb-2">
                                <button type="button" class="btn btn-link btn-sm text-muted font-18"><i class="dripicons-paperclip"></i></button>
                            </div>-->
                            <div class="btn-group mb-2 ms-2">
                                <button type="submit" class="btn btn-primary btn-sm">Submit</button>
                            </div>
                        </div>
                    </form>

                    <div class="d-flex align-items-start mt-2">
                        <div class="w-100 overflow-hidden" v-for="comment in project.comments" :key="comment.id">
                            <h5 class="mt-0">{{ comment.author.name }}</h5>
                            
                            {{ comment.comment }}
                        </div>
                    </div>

                    <!--<div class="text-center mt-2">
                        <a href="javascript:void(0);" class="text-danger">Load more </a>
                    </div>-->
                </div> <!-- end card-body-->
            </div>
        </div>
    </div>
    <!-- end row -->    
    <Create
        v-if="isOpen"
        @modelStatusChanged="modalStatus"
        :project="projectToEdit"
        :customers="customers"
        :users="users"
        :isEdit="isEdit"
    />
</template>

<script>
import Main from "@/Layouts/Main.vue";
import Create from "@/Pages/Project/Form.vue";
import EditButton from "@/Components/EditButton.vue";
import DeleteButton from "@/Components/DeleteButton.vue";
import ConfirmBox from "@/Components/ConfirmBox.vue";
import Pagination from "@/Components/Pagination.vue";
import moment from 'moment';

import Phases from "@/Pages/Project/single-project/Phases.vue";

export default {
    layout: Main,
    props: {
        auth: Object,
        errors: Object,
        project: Object,
        users: Array,
        customers: Array,
        flash: Object,
    },
    components: {
        Create,
        EditButton,
        DeleteButton,
        ConfirmBox,
        Pagination,
        Phases
    },
    data() {
        return {
            projectToEdit: null,
            isOpen: false,
            isEdit: false,
            newComment: '',
            showConfirmBox: false,
            new_member: null,
            pipeline: {
                lead: null,
                develop: null,
                purpose: null,
                contract: null,
                initiate: null,
                run: null,
                wrap_up: null,
                bill: null,
                close: null,
            }
        };
    },
    methods: {
        formatDate (date) {
            return moment(date).format('Do MMM YYYY')
        },
        edit(project) {
            this.projectToEdit = project;
            
            this.isEdit = true;
            this.isOpen = true;
        },
        addNew () {
            this.project = null;
            
            this.isEdit = false;
            this.isOpen = true;
        },
        confirnDelete(project) {
            this.project = project;
            this.showConfirmBox = true;
        },
        modalStatus(status) {
            this.isOpen = status;
        },
        hideConfirmation() {
            this.showConfirmBox = false;
        },
        deleteProject() {
            this.$inertia.delete(
                this.route("projects.destroy", this.project.id)
            );
        },
        async addMember (id) {
            try {
                const response = await axios.post('/project/add-member', {
                    id: id,
                    project_id: this.project.id
                }); // Replace with your actual endpoint
                console.log('Member added:', response.data);
                // Optionally, you can update your UI or perform other actions here
            } catch (error) {
                console.error('Error adding member:', error);
            }

            let newMember = {
                user_id: id,
                project_id: this.project.id,
                user: this.users[id]
            }

            this.project.members.push(newMember)
        },
        async removeMember (id, key) {
            try {
                const response = await axios.post('/project/remove-member', {
                    id: id
                }); // Replace with your actual endpoint
                console.log('Member removec:', response.data);

                this.project.members.splice(key, 1)
                // Optionally, you can update your UI or perform other actions here
            } catch (error) {
                console.error('Error removing member:', error);
            }
        },
        async submitComment() {
            try {
                const response = await axios.post('/project/save-comment', {
                    comment: this.newComment,
                    author_id: this.auth.user.id,
                    project_id: this.project.id,
                }); // Replace with your actual endpoint
                console.log('Comment saved:', response.data);
                // Optionally, you can update your UI or perform other actions here
            } catch (error) {
                console.error('Error submitting comment:', error);
            }

            let newComment = {}
            newComment.comment = this.newComment
            newComment.author = this.auth.user

            this.project.comments.push(newComment)
            this.newComment = ''
        },
        async submitPipeline () {
            try {
                const response = await axios.post('/project/save-pipeline', {
                    pipeline: this.pipeline,
                    project_id: this.project.id,
                }); // Replace with your actual endpoint
                console.log('Pipeline saved:', response.data);
                // Optionally, you can update your UI or perform other actions here
            } catch (error) {
                console.error('Error submitting pipeline:', error);
            }
        }
    },

    computed: {
        deleteConfirmation() {
            return `Are you sure went to delete ${this.project.name}?`;
        },
    },
    mounted() {
        this.$store.dispatch("setAuth", this.auth);
        
        if(this.project.pipeline) this.pipeline = this.project.pipeline

        if (this.flash.success) {
            var toast = {
                bg: "bg-success",
                message: this.flash.success,
            };
        }
        if (toast) {
            this.$store.dispatch("showToast", toast);
        }
    },
    updated() {
        if (this.flash.success) {
            var toast = {
                bg: "bg-success",
                message: this.flash.success,
            };
        }
        if (toast) {
            this.$store.dispatch("showToast", toast);
        }
    },
};
</script>

<style>
    .single-member {
        border: 1px solid #e2e2e2;
        padding: 12px;
        text-align: center;
    }
    .remove-member-icon {
        font-size: 16px;
        color: red;
        cursor: pointer;
    }
</style>